// extracted by mini-css-extract-plugin
module.exports =  {"title":"title--OitGK","error":"error--DIzf0"};